import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
declare let $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  @Input() sidebar: any;
  mini: boolean = true;
  language: any;
  screenWidth: any;
  showImage = false;
  expiryDate: any;
  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.screenWidth = window.screen.width;
   const storedDate = localStorage.getItem('bannerExpiryDate');
    this.expiryDate = storedDate ? new Date(storedDate) : null;
    const now = new Date();
    const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expiryDateOnly = new Date(this.expiryDate.getFullYear(), this.expiryDate.getMonth(), this.expiryDate.getDate());
    this.showImage = nowDateOnly <= expiryDateOnly;
  }


  collapseSidebar() {
    if (this.mini) {
      if (this.screenWidth >= 992 && this.screenWidth <= 1024) {
        $("#mySidebar").css({ 'width': "240px" });
        $("#mySidebar a span").css('display', "block");
        $(".q-logo2").css('display', "none");
        $(".q-logo1").css('display', "block");
        $("#overlay").css({ 'background': "rgba(0,0,0,0.5)", 'width': '100%' });
      } else {
        $("#mySidebar").css({ 'width': "250px" });
        $("#main").css('margin-left', "250px");
        $("#mySidebar a span").css('display', "block");
        $(".q-logo2").css('display', "none");
        $(".q-logo1").css('display', "block");
        $("#overlay").css({ 'background': "none", 'width': '0' });
      }

      this.mini = false;
    } else {
      $("#mySidebar").css('width', "85px");
      $("#overlay").css({ 'background': "none", 'width': '0' });
      $("#main").css('margin-left', "85px");
      $("#mySidebar a span").css('display', "none");
      $(".q-logo1").css('display', "none");
      $(".q-logo2").css('display', "block");

      this.mini = true;
    }

  }

  emptySession() {
    sessionStorage.clear();
  }
}

